import { PLUGIN_NAME } from '../config';
import DebugUANC from '../../../core/version/debug';
import { ITcfData, KeywordsMap } from '../../../uanc.types';

/**
 * Nasłuchuje tcfapi i pobiera konfigurację.
 *
 * @returns {Promise<ITcfData | null>} Pobrana konfiguracja TCF
 */
const getTcfData = async (): Promise<ITcfData | null> => {
    if (window.__tcfapi)
        return new Promise((resolve) => {
            const getData = (tcfData: ITcfData, success: boolean) => {
                if (success && tcfData.eventStatus === 'tcloaded') resolve(tcfData);
                else return null;
            };
            window.__tcfapi('addEventListener', 2, getData);
        });
    else return null;
};

/**
 * Inicjuje plugin TCFKeywords.
 * Wykorzystuje API tcf do pobrania zgód rodo na podstawie których definiuje keywordy
 *
 * @returns {Promise<PLUGIN_NAME | Error>} Nazwa załadowanego pluginu lub w przypadku problemów przekazanie informacja o błędzie.
 */
export const processTCFKeywords = async (): Promise<PLUGIN_NAME | Error> => {
    const { Ad } = window.Inpl;
    let ltd = 1;

    try {
        if (!Ad.tcfData) {
            Ad.tcfData = await getTcfData();
            Ad.tcfData?.purpose?.consents[1] && (ltd = 0);
        }

        const keywords: KeywordsMap = {
            ltd: ltd,
        };

        Ad.plugins = {
            ...Ad.plugins,
            [PLUGIN_NAME.TCF_KEYWORDS]: {
                isEnabled: true,
                keywords,
            },
        };

        if (Ad.UANC instanceof DebugUANC) {
            Ad.UANC.info('Plugin TCFKeywords', `has been successfully embedded, Keywords: ${JSON.stringify(keywords, null, 2)}`);
        }

        return PLUGIN_NAME.TCF_KEYWORDS;
    } catch (e) {
        throw new Error(`[TCFKeywords] - problem with receiving the data. ${e}`);
    }
};
